import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

/**
 * Load the full version history (change log) for a company configuration —
 * every version, PUBLISHED and RETIRED alike. The backend returns them
 * ascending by version number; callers that want newest-first should sort.
 * The query is disabled until a `configCode` is provided.
 */
export function useCompanyConfigChangeLog(configCode: string | undefined) {
  return useQuery({
    queryKey: ["companyConfig", configCode, "versions"],
    queryFn: () => api.getCompanyConfigChangeLog(configCode as string),
    enabled: Boolean(configCode),
  });
}
